/** Full closed vocabulary of section keys. Mirrors tangrowth's `SectionKey` StrEnum. */
export enum SectionKey {
  abstract = "abstract",
  introduction = "introduction",
  methods = "methods",
  results = "results",
  discussion = "discussion",
  conclusion = "conclusion",
  funding = "funding",
  coi = "coi",
  disclosures = "disclosures",
  other = "other",
}
